import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RecentProofCard = ({ proof, onOpenDetail }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    if (onOpenDetail) {
      onOpenDetail(proof?.id);
      return;
    }
    navigate('/proof-detail-view', { state: { proofId: proof?.id } });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return d?.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-card rounded-lg shadow-gaming-md overflow-hidden transition-gaming hover:shadow-gaming-lg cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden bg-muted">
        <Image
          src={proof?.image}
          alt={proof?.imageAlt}
          className="w-full h-full object-cover transition-gaming"
        />
      </div>
      <div className="p-4 md:p-5 space-y-3">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-1 line-clamp-1">
              {proof?.challengeName}
            </h4>
            <p className="text-sm text-muted-foreground caption line-clamp-1">
              {proof?.projectName}
            </p>
          </div>
          <div className="flex items-center space-x-1 ml-2">
            {[...Array(5)]?.map((_, index) => (
              <Icon
                key={index}
                name="Star"
                size={14}
                color="currentColor"
                className={index < proof?.stars ? 'fill-current text-primary' : 'text-muted-foreground'}
              />
            ))}
          </div>
        </div>
        <div className="flex items-center justify-between text-xs md:text-sm text-muted-foreground">
          <div className="flex items-center space-x-2">
            <Icon name="Calendar" size={14} />
            <span className="caption">{formatDate(proof?.submittedAt)}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Hash" size={14} />
            <span className="data-text">{proof?.proofNumber}</span>
          </div>
        </div>
        {proof?.isPublic && (
          <div className="flex items-center space-x-2 text-xs text-success">
            <Icon name="Eye" size={14} />
            <span className="caption">공개</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentProofCard;